module.exports = __webpack_public_path__ + "img/S501.ceaf5016.jpg";